export const SelectionType = {
    TypOsoby: 10,
    FrekvencePlatby: 12,
    ZpusobPlatby: 13,
    FormaSjednani: 38,
    PersonSameAs: 41,
    DruhVozidla: 4,
    NonregisteredVehicleSubcategory: 62,
    PouzitiVozidla: 5,
    PuvodVozidla: 6,
    Palivo: 7,
    PojisteniSBezDph: 8,
    DelkaPojisteni: 11,
    Zabezpeceni: 14,
    CenaVozidlaZ: 15,
    DruhRegZnacky: 33,
    UzemniPlatnost: 34,
    Pov: 35,
    Hav: 36,
    Spol: 37,
    Pripojisteni: 39,
    Vybava: 40,
    DruhTp: 44,
    MakeModelIdType: 48,
    RozsahPojisteni: 43,
    Horlavost: 16,
    PlochaPodsklepení: 17,
    KonstrukcniPrvky: 18,
    TypBudovy: 19,
    DokonceniNemovitosti: 20,
    TypStrechy: 21,
    VyuzivaKdo: 22,
    Vybaveni: 23,
    DalsiNemovitost: 24,
    TypNemovitosti: 25,
    TypKonstrukce: 26,
    Stav: 27,
    Vlastnictvi: 28,
    TypBytovehoDomu: 29,
    VztahKPremetuPojisteni: 31,
    StavRekonstrukce: 32,
    StavInterieru: 66,
    DispoziceBytu: 67,
    TypParkovaniVozidla: 68,
    ZpusobVraceniPreplatkuNahrazovaneSmlouvy: 63,
    ZpusobPrvniPlatby: 64,
    ZpusobDigitalnihoPodpisu: 65,
    LeasingType: 45,
    PurchaseMethod: 46,
    VehicleYearKm: 47,
    WarrantyLimitKm: 49,
    WarrantyMonthLimit: 50,
    TitleBefore: 51,
    Vinkulant: 52,
    VinkulationType: 53,
    TravelDestination: 55,
    TravelType: 56,
    TravelReason: 57,
    TravelSportType: 58,
    TravelDestEuropeCountry: 60,
    TravelPaymentState: 70,
    RelationInsuredToPolicyHolder: 71
} as const

export type SelectionType = typeof SelectionType[keyof typeof SelectionType]

export default SelectionType